import React from 'react';
import classNames from 'classnames';
import { ExpertModel } from '@/types';
import ResponsiveImage from '../general/ResponsiveImage';

type QuoteElementModel = {
  expert: ExpertModel;
} & React.HTMLAttributes<HTMLDivElement>;

const Quotee = ({ expert, className, ...props }: QuoteElementModel) => {
  if (!expert) {
    return null;
  }

  const { image, expertName, jobTitle } = expert;

  return (
    <div
      className={classNames(
        'quotee flex flex-row items-center sm:flex-col sm:items-start sm:justify-center',
        !image && 'sm:ml-3 lg:ml-16 xl:ml-24',
        className,
      )}
      {...props}
    >
      {image && (
        <div className="py-3 md:px-0">
          <div className="xxl:w-[169px] aspect-square w-[69px] sm:w-[121px] md:mx-4">
            <ResponsiveImage
              className=""
              imgProps={{ className: 'rounded-full  ' }}
              image={{ ...image, imageAlt: expertName }}
              widths={{ xs: 69, sm: 121, md: 121, lg: 169, xl: 169 }}
              heights={{ xs: 69, sm: 121, md: 121, lg: 169, xl: 169 }}
            />
          </div>
        </div>
      )}
      <div
        className={classNames(
          'color-from-bg ml-6 flex w-full flex-col py-3 sm:ml-0',
          image && 'sm:items-center md:text-center',
        )}
      >
        <div className="body-1">{expertName}</div>
        <div className="body-1">{jobTitle}</div>
      </div>
    </div>
  );
};

export default Quotee;
